import Vue from 'vue'
import VueRouter from 'vue-router'

// import store from '@/state/store'
import routes from './routes'



Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})


// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  const userToken = localStorage.getItem("TOKEN");
  const loggedUser = localStorage.getItem("USER");

  if (!userToken && !loggedUser) {
    if(routeTo.meta.isGuest && routeTo.path === '/reset-password'){
      const checkQueryResetPassword = routeTo.query.userId && routeTo.query.token;

      if(!checkQueryResetPassword){
        return next({ name: "404" });
      }
    }
    if(routeTo.meta.authRequired){
      return next({ name: "Public Search" });
    }
  } 
  if (userToken && loggedUser) {
    if(routeTo.meta.isGuest){
      return next({ name: "Archive" });
    }
    if(routeTo.meta.authRequired){
      // If auth is required and the user is accessing in admin pages...
      const authAdminPage = routeTo.fullPath.includes('/admin');
      
      if (authAdminPage) {
        const isUserAdmin = Vue.prototype.$isAdmin() || false;

        if(!isUserAdmin){
          return next({ name: "404" });
        }
      }
    }

  }

  next();
})


export default router
